/**
 * Canonical values persisted by the Rawam API.
 *
 * Keep these values aligned with CoEIA.Rawam.Commons.Constants. Do not repeat
 * numeric domain codes in components or services.
 */
export const USER_STATUS = Object.freeze({
  ACTIVE: 0,
  RESIGNED: 1,
  WAITING_RESIGNATION_APPROVAL: 2,
  SUSPENDED: 3,
  WAITING_ACTIVATION_APPROVAL: 4,
  EXPIRED: 5,
})

export const INVITATION_STATUS = Object.freeze({ SENT: 0, USER_REGISTERED: 1, CANCELED: 2 })
export const GROUP_TYPE = Object.freeze({ DEPARTMENTS: 1, OTHERS: 2 })
export const GROUP_SOURCE = Object.freeze({ ADMIN: 0, SYSTEM: 1, LDAP: 2, ENTRA: 3 })
export const CATEGORY_PUBLICITY = Object.freeze({ PUBLIC: 0, PRIVATE: 1 })
export const COURSE_CONTENT_TYPE = Object.freeze({ MP4: 0, SCORM: 1 })
export const COURSE_EXAM_DISPLAY_STATE = Object.freeze({
  NOT_TAKEN: 1,
  PASSED: 2,
  FAILED: 3,
  NOT_COMPLETED: 4,
})

export const SURVEY_TYPE = Object.freeze({ GENERAL: 1, COURSE: 2, PROGRAM: 3 })
export const SURVEY_RESTRICTION_METHOD = Object.freeze({
  COURSE_AFTER_WATCHING_CONTENT: 1,
  COURSE_AFTER_TAKING_EXAM: 2,
  PROGRAM_AFTER_FINISHING_ALL_COURSES: 3,
  PROGRAM_AFTER_FINISHING_ALL_COURSES_SUCCESSFULLY: 4,
})
export const SURVEY_QUESTION_TYPE = Object.freeze({
  RADIO: 1,
  CHECKBOX: 2,
  YES_NO: 3,
  STARS: 4,
  SHORT_TEXT: 5,
  LONG_TEXT: 6,
})

export const PHISHING_DIFFICULTY = Object.freeze({ EASY: 0, NORMAL: 1, HARD: 2 })
export const PHISHING_PAYLOAD_TYPE = Object.freeze({ WEBSITE: 0, ATTACHMENT: 1, INFORMATION_REQUEST: 2 })
export const PHISHING_USER_STATUS = Object.freeze({
  SCHEDULED: -1,
  SENT: 0,
  EMAIL_OPENED: 1,
  LINK_CLICKED: 2,
  DATA_SUBMITTED: 3,
  USER_REPORTED: 4,
})

export const CERTIFICATE_PRINT_LANGUAGE = Object.freeze({ ARABIC: 1, ENGLISH: 2, USER_INTERFACE: 3 })
export const CERTIFICATE_VALIDITY_TYPE = Object.freeze({ DAYS: 1, MONTHS: 2, YEARS: 3 })
export const CERTIFICATE_VALIDITY_VISIBILITY = Object.freeze({ ADMINS_AND_USERS: 0, ADMINS_ONLY: 1, USERS_ONLY: 2 })
export const CERTIFICATE_DATE_FORMAT = Object.freeze({ GREGORIAN: 1, HIJRI: 2, BOTH: 3, PRINT_LANGUAGE: 4 })
export const CERTIFICATE_DATE_CONFIGURATION = Object.freeze({
  LAST_COURSE: 1,
  LAST_EXAM: 2,
  PROGRAM_START_AND_LAST_COURSE: 3,
  PROGRAM_START_AND_LAST_EXAM: 4,
})
export const SAVE_OPERATION = Object.freeze({ CREATE: 0, UPDATE: 1 })
export const ENTITY_ID = Object.freeze({ NEW: -1, NONE: 0 })
export const QUESTION_CORRECT_ANSWER = Object.freeze({ NONE: 0, OPTION_ONE: 1, OPTION_TWO: 2, OPTION_THREE: 3, OPTION_FOUR: 4 })
export const COURSE_EXCEPTION_TYPE = Object.freeze({ NONE: 0, EXAM_TRIES: 1, ATTEND_UNTIL: 2, BOTH: 3 })
export const NOTIFICATION_SCHEDULE_TYPE = Object.freeze({ MINUTES_FROM_NOW: 1, DAYS_FROM_NOW: 2, SPECIFIC_DATE_TIME: 3 })
export const NOTIFICATION_EVENT_TYPE = Object.freeze({ COURSE_START: 1, COURSE_END: 2 })
export const POINTS_EVENT_TYPE = Object.freeze({ PASS_TESTS: 6 })

export const AUTHENTICATION_METHOD = Object.freeze({ LOCAL: 1, ACTIVE_DIRECTORY: 2, ACTIVE_DIRECTORY_AND_LOCAL: 3, PASS_LINK: 4, ENTRA_ID: 5, ENTRA_ID_AND_LOCAL: 6 })
export const GENDER = Object.freeze({ MALE: 1, FEMALE: 2 })
export const APPROVAL_CODE = Object.freeze({ NOT_APPROVED: 0, APPROVED: 1 })
export const DIFFICULTY = Object.freeze({ HARD: 1, INTERMEDIATE: 2, EASY: 3, ADVANCED: 4, ASSESSMENT: 5 })
export const SURVEY_YES_NO_ANSWER = Object.freeze({ YES: 1, NO: 2 })

export const HTTP_STATUS = Object.freeze({ OK: 200, CREATED: 201, ACCEPTED: 202, NO_CONTENT: 204, MOVED_PERMANENTLY: 301, FOUND: 302, NOT_MODIFIED: 304, BAD_REQUEST: 400, UNAUTHORIZED: 401, FORBIDDEN: 403, NOT_FOUND: 404, METHOD_NOT_ALLOWED: 405, CONFLICT: 409, PAYLOAD_TOO_LARGE: 413, UNSUPPORTED_MEDIA_TYPE: 415, IM_ATEAPOT: 418, UNPROCESSABLE_ENTITY: 422, TOO_MANY_REQUESTS: 429, INTERNAL_SERVER_ERROR: 500, BAD_GATEWAY: 502, SERVICE_UNAVAILABLE: 503 })

export const VERIFICATION_METHOD = Object.freeze({ OPEN: 1, CLOSE: 2, TIME_STAMP: 3, NUMBER_OF_USERS: 4, NUMBER_OF_USERS_AND_TIME_STAMP: 5 })

export const USER_ACTIVATION_METHOD = Object.freeze({ EMAIL: 1, ADMIN: 2 })
export const USERNAME_FORMAT_CODE = Object.freeze({ UNCHANGED: '1', EXTRACT_USERNAME: '2', REJECT_EMAIL: '3' })

export const EXAM_STATE = Object.freeze({ IN_PROGRESS: 0, PASS: 1, FAIL: 2, PASS_BUT_NOT_COMPLETE: 3, FAIL_BUT_NOT_COMPLETE: 4, UNATTENDED: 5 })
export const EXAM_SCORING = Object.freeze({ INCORRECT: 0, CORRECT: 1, UNANSWERED_SELECTION: -1 })
